import axios from 'axios';
import { get } from 'lodash';
import adminApi from 'services/admin/adminApi';


/**
 * method calling serverless lambda function to fetch url to render Dashboard Iframe
 * @param type
 * @param setDashboardUrl
 * @param setDashboardUrlLoading
 * @param setDashboardUrlError
 * @returns {Promise<void>}
 */
export const fetchDashboardUrl = async ({ type, setDashboardUrl, setDashboardUrlLoading, setDashboardUrlError }) => {
  try {
    const res = await axios.get(adminApi.getDashboardUrl(type));
    setDashboardUrl(get(res, 'data.url', ''));
  } catch (error) {
    setDashboardUrlError(error);
  } finally {
    setDashboardUrlLoading(false);
  }
};
